import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class TinyClose extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('Lapel'),
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 24 24"
        width={width}
      >
        <g fill={strokeColor}>
          <path d="M13.41,12l4.34-4.34a1,1,0,0,0-1.41-1.41L12,10.63,7.66,6.29A1,1,0,0,0,6.25,7.71L10.59,12,6.29,16.34a1,1,0,1,0,1.41,1.41L12,13.46l4.29,4.29a1,1,0,1,0,1.41-1.41Z" />
        </g>
      </SVGElement>
    );
  }
}
